document.addEventListener("DOMContentLoaded", () => {
  const tabsModules = document.querySelectorAll(".tabs-v1");

  tabsModules.forEach((module) => {
    const tabs = module.querySelectorAll(".tabs-v1__li");
    const contentItems = module.querySelectorAll(".tabs-v1__content-item");

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const index = tab.getAttribute("data-index");

        tabs.forEach((t) => t.classList.remove("isActive"));
        contentItems.forEach((c) => c.classList.remove("isActive"));

        tab.classList.add("isActive");
        const content = module.querySelector(
          `.tabs-v1__content-item[data-index="${index}"]`
        );
        if (content) {
          content.classList.add("isActive");
        }
      });
    });
  });

  const styleTenModules = document.querySelectorAll(".tab-style-ten");

  styleTenModules.forEach((styleTenModule) => {
    const subTabsNav = styleTenModule.querySelector(
      ".tab-style-ten__sub-tabs-nav"
    );
    if (!subTabsNav) return;
    const subTabItems = subTabsNav.querySelectorAll(
      ".tab-style-ten__sub-tab-item"
    );
    const subContentPanels = styleTenModule.querySelectorAll(
      ".tab-style-ten__sub-content-panel"
    );

    // Helper to activate a sub tab without triggering scroll
    const activateSubTab = (subTab) => {
      const subIndex = subTab.dataset.index;
      subTabItems.forEach((s) => s.classList.remove("isActive"));
      subContentPanels.forEach((c) => c.classList.remove("isActive"));
      subTab.classList.add("isActive");
      const subContent = styleTenModule.querySelector(
        `.tab-style-ten__sub-content-panel[data-index="${subIndex}"]`
      );
      if (subContent) {
        subContent.classList.add("isActive");
      }
    };

    subTabItems.forEach((subTab) => {
      const subButton = subTab.querySelector("button");
      if (subButton) {
        subButton.addEventListener("click", (ev) => {
          const subIndex = subTab.dataset.index;

          subTabItems.forEach((s) => s.classList.remove("isActive"));
          subContentPanels.forEach((c) => c.classList.remove("isActive"));

          subTab.classList.add("isActive");
          const subContent = styleTenModule.querySelector(
            `.tab-style-ten__sub-content-panel[data-index="${subIndex}"]`
          );
          if (subContent) {
            subContent.classList.add("isActive");
            // Solo hacer scroll si el clic fue del usuario
            if (ev && ev.isTrusted) {
              setTimeout(() => {
                const yOffset = -100;
                const y =
                  subContent.getBoundingClientRect().top +
                  window.pageYOffset +
                  yOffset;

                window.scrollTo({
                  top: y,
                  behavior: "smooth",
                });
              }, 50);
            }
          }
        });
      }
    });

    // Activación inicial sin clic programático ni scroll
    const initialActiveBtn = subTabsNav.querySelector(
      ".tab-style-ten__sub-tab-item.isActive"
    );
    if (initialActiveBtn) {
      activateSubTab(initialActiveBtn);
    } else {
      const firstSubTab = subTabsNav.querySelector(
        ".tab-style-ten__sub-tab-item:first-child"
      );
      if (firstSubTab) {
        activateSubTab(firstSubTab);
      }
    }
  });
});
